import "./ShapeFive.css";

export default function ShapeFive() {
  return (
    <div className="shape-5">
      <p>
        created by <br></br>
        <span>asticodes.dev</span>
      </p>
    </div>
  );
}
